import { useTranslation } from 'react-i18next';

import { Select } from '@actual-app/components/select';
import { View } from '@actual-app/components/view';
import type { AccountEntity } from '@actual-app/core/types/models';

import { useSyncedPref } from '#hooks/useSyncedPref';

import { getPortfolioGroup, portfolioGroups } from './accountPortfolio';
import { usePortfolioLabels } from './usePortfolioLabels';

export function PortfolioGroupSelect({ account }: { account: AccountEntity }) {
  const { t } = useTranslation();
  const labels = usePortfolioLabels();
  const prefKey = `account-portfolio-group-${account.id}` as const;
  const [saved, setGroup] = useSyncedPref(prefKey);
  const value = getPortfolioGroup(account, { [prefKey]: saved });
  return (
    <View style={{ padding: '0 14px 8px' }}>
      <Select
        aria-label={t('{{name}} 계좌 분류', { name: account.name })}
        value={value}
        onChange={setGroup}
        options={portfolioGroups.map(group => [group.id, labels[group.id]])}
      />
    </View>
  );
}
